import _ from 'lodash'
import request from 'superagent'
import Immutable from 'immutable'
import * as types from '../actionTypes/pacerSearchActionTypes'


function getUrlForEnv(url) {
  return (process.env.NODE_ENV === 'test')
    ? "http://localhost" + url
    : url
}

function requestBankruptcySearch(params) {
  return {
    type: types.REQUEST_BANKRUPTCY_SEARCH,
    params
  }
}

function requestBankruptcyLocalSearch(params) {
  return {
    type: types.REQUEST_BANKRUPTCY_LOCAL_SEARCH,
    params
  }
}

function requestAppellateSearch(params) {
  return {
    type: types.REQUEST_APPELLATE_SEARCH,
    params
  }
}

function receiveSearchResults(params, response) {
  return {
    type: types.RECEIVE_SEARCH_RESULTS,
    params,
    searchResults: response.items || {},
    searchOptions: response.config || {},
    source_data_id: response.source_data_id,
  }
}

function requestViewSearch(params) {
  return {
    type: types.REQUEST_VIEW_SEARCH,
    params
  }
}

function requestCivilSearch(params) {
  return {
    type: types.REQUEST_CIVIL_SEARCH,
    params
  }
}

function requestCriminalSearch(params) {
  return {
    type: types.REQUEST_CRIMINAL_SEARCH,
    params
  }
}

export function receiveError(type, errors) {
  return {
    type: type,
    errors: errors
  }
}

function mapFiltersToParams(f) {
  //todo clean this up and move to separate file
  const filters = f.toJS()
  const serviceParams = { service: 'query', query_type: 'search' }
  let sortParams

  if (typeof(filters.sort) === 'object') {
    sortParams = {
      active: {
        sort_field: filters.sort.activeField.key,
        sort_reverse: filters.sort.isReverse
      }
    }
  }

  if (!_.isEmpty(filters.chapter)) {
    filters.chapter = filters.chapter.split(",")
  }

  if (_.isEmpty(filters.court_id)) {
    filters.court_id = '00'
  }

  // Get MM/DD/YYYY from moment objects
  ['filed_from', 'filed_to',
    'closed_from', 'closed_to',
    'dismissed_from', 'dismissed_to',
    'discharged_from', 'discharged_to'
  ].forEach(date_field => {
    if (!_.isEmpty(filters[date_field]))
      filters[date_field] = filters[date_field].format("MM/DD/YYYY")
  })

  return Object.assign({}, serviceParams, filters, { sort: sortParams })
}

function removeFalsyValues(obj) {
  const filters = Object.assign({}, obj.filters, _.pickBy(filters, _.identity))
  const root = _.pickBy(obj, _.identity);
  return Object.assign({}, root, filters)
}

function mapResponseErrorsToMessage(err) {
  const request_id = _.get(err, ['response', 'body', 'error', 'request_id']);
  const errorMessageExtra = request_id
    ? `When contacting support, please quote Request ID '${request_id}'`
    : '';

  if (_.get(err, ['response', 'body', 'error', 'errorMessage'], '') == "Not enough Credits") {
    window.location = '/prepaid/credits?destination=' + decodeURIComponent(window.location.pathname);
    return {
      messages: [
        'Insufficient credits, opening payment screen...',
      ]
    }
  }

  return {
    // We want to hide real messages from user since traces are confusing to them
    // TODO: coordinate with API to surface proper errors such as field validation?
    messages: [
      'PACER is experiencing some issues. Please try again in a few minutes.',
      errorMessageExtra
    ],
    // but we include the real message in the details so we receive it in the sentry report
    details: _.get(err, ['response', 'body', 'error']) || []
  };
}

function onSuccess(dispatch, filters) {
  return function (response) {
    return dispatch(receiveSearchResults(Immutable.fromJS(filters), response.body))
  }
}

function onFailure(dispatch) {
  return function (err) {
    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)))
  }
}

export const searchView = (filters) => {
  return function (dispatch, getState) {
    dispatch(requestViewSearch(filters))
    const body = mapFiltersToParams(filters)
    const searchParams = removeFalsyValues(body)

    // fix page number if we click sort before paging, probably better suited elsewhere, like receiving results...
    if (!searchParams.page) searchParams.page = 1;

    const state = getState()
    const search_id = state.getIn(['pacerSearchResults', 'searchOptions', 'search_id'])
    const resultset = state.getIn(['pacerSearchResults', 'searchOptions', 'resultset'])
    const filtersObj = filters.toJS()
    const url = `/pacer/search/view/${state.getIn(['pacerSearchResults', 'query_type'])}`

    return request
      .post(getUrlForEnv(url))
      .send({
        search_id: search_id,
        resultset: resultset,
        sort_field: filtersObj.sort.activeField.key,
        sort_reverse: filtersObj.sort.isReverse,
        page_no: searchParams.page,
      })
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .then(onSuccess(dispatch, filters), onFailure(dispatch))
  }
}

export const searchBankruptcies = (filters) => {
  return function (dispatch) {
    dispatch(requestBankruptcySearch(filters))
    const params = mapFiltersToParams(filters)
    let searchParams = removeFalsyValues(params)

    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
    searchParams = _.omit(searchParams, [
      'last_business_name',
      'case_type',
    ]);

    return request
    //.get('http://127.0.0.1:8080/data/pacer-search/search_bk_case.json')
      .post(getUrlForEnv('/pacer/search/bk'))
      .send(searchParams)
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .then(onSuccess(dispatch, filters), onFailure(dispatch))
  }
}

export const searchBankruptciesLocal = (filters) => {
  return function (dispatch) {
    dispatch(requestBankruptcyLocalSearch(filters))
    const params = mapFiltersToParams(filters)
    let searchParams = removeFalsyValues(params)

    //remove filters
    searchParams = _.omit(searchParams, [
      'party_name', 'case_type'
    ]);

    return request
    //.get('http://127.0.0.1:8080/data/pacer-search/search_bk_case.json')
      .post(getUrlForEnv('/pacer/search/bk-localcourts'))
      .send(searchParams)
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .then(onSuccess(dispatch, filters), onFailure(dispatch))
  }
}

export const searchAppellates = (filters) => {
  return function (dispatch) {
    dispatch(requestAppellateSearch(filters))
    const params = mapFiltersToParams(filters)
    let searchParams = removeFalsyValues(params)

    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
    searchParams = _.omit(searchParams, [
      'last_business_name',
      'case_type'
    ]);

    return request
    //.get('http://127.0.0.1:8080/data/pacer-search/search_bk_case.json')
      .post(getUrlForEnv('/pacer/search/ap'))
      .send(searchParams)
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .then(onSuccess(dispatch, filters), onFailure(dispatch))
  }
}

export const searchCivil = (filters) => {
  return function (dispatch) {
    dispatch(requestCivilSearch(filters))

    const params = mapFiltersToParams(filters)
    let searchParams = removeFalsyValues(params)

    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
    searchParams = _.omit(searchParams, [
      'last_business_name',
      'case_type'
    ]);

    return request
    //.get('http://127.0.0.1:8080/data/pacer-search/search_cv_case.json')
      .post(getUrlForEnv('/pacer/search/cv'))
      .send(searchParams)
      .set('Accept', 'application/json')
      .then(onSuccess(dispatch, filters), onFailure(dispatch))
  }
}

export const searchCriminal = (filters) => {
  return function (dispatch) {
    dispatch(requestCriminalSearch(filters))

    const params = mapFiltersToParams(filters)
    let searchParams = removeFalsyValues(params)

    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
    searchParams = _.omit(searchParams, [
      'last_business_name',
      'case_type'
    ]);

    return request
    //.get('http://127.0.0.1:8080/data/pacer-search/search_cr_party.json')
      .post(getUrlForEnv('/pacer/search/cr'))
      .send(searchParams)
      .set('Accept', 'application/json')
      .then(onSuccess(dispatch, filters), onFailure(dispatch))
  }
}

export const resetSearchResults = () => {
  return {
    type: types.RESET_SEARCH_RESULTS
  }
}

export const updateFilter = (filter) => {
  return {
    type: types.UPDATE_FILTER,
    filter: filter
  }
}

export const resetFilters = () => {
  return {
    type: types.RESET_FILTERS
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/pacerSearch.js